import { CSSProperties, FC, ButtonHTMLAttributes } from "react";
import './SButton.scss'

interface SButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    style?: CSSProperties | undefined;
    children: React.ReactNode;
    onClick?: () => void;
}

const SButton: FC<SButtonProps> = (props) => {
    return (
        <button
            onClick={props.onClick}
            className='s-button-wrapper'
            style={{ ...props.style }}
            type={props.type} disabled={props.disabled}
        >
            {props.children}
        </button>
    )
}

export default SButton;
